import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Carousel from '../Carousel/Carousel'
import { deviceMax } from '../../theme/breakpoints'

export const StyledCarrouselBlock = styled.section`
  display: flex;
  max-width: ${pxToRem(800)};
  width: 100%;
  margin-bottom: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.tablet} {
    flex-direction: column;
    max-width: initial;
    border-radius: initial;
  }
`

export const StyledCarousel = styled(Carousel)`
  max-width: ${pxToRem(290)};
  margin: 0;

  .slick-list {
    border-radius: ${pxToRem(4)};
  }

  @media ${deviceMax.tablet} {
    max-width: initial;
    width: 100%;
  }
`

export const StyledInformations = styled.div`
  display: ${({ $isActive }) => ($isActive ? 'flex' : 'none')};
  flex-direction: column;
  gap: ${pxToRem(10)};
  width: 100%;
  padding: ${pxToRem(20)};
`

export const StyledTitle = styled.h2`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  line-height: normal;
`
